export const BASE_URL =
  // "https://backend.queenags.com/api/admin/";
// "https://uat-script.queenags.com/api/admin/";
// "http://192.168.1.44:8000/api/admin/";
"https://backend.garudaags.com/api/admin/";
// "https://uat-backend.Garudaags.com/api/admin/";

// export const WEBSOCKET_URL = "ws://192.168.1.44:9502";
// export const WEBSOCKET_URL = "wss://uat-script.queenags.com/ws/";
export const WEBSOCKET_URL = "wss://backend.garudaags.com/ws/";


export const URLS = {
  LOGIN: "login",
  LOGOUT: "logout",
  FORGOTPASSWORD: "forgot-password",
  VERIFYOTP: "verify-otp",
  CHANGEPASSWORD: "update-password",
  ADMINLIST: "users",
  CLIENT: "clients",
  CLIENTAMOUNTADD: "/clients/wallet/transection",
  CLINETWALLETHISTORY: "/clients/wallet/history",
  ADMINRECHARGEBANK: "/clients/wallet/recharge",
  MASTER: "master/by-type",
  LINKUPDATE: "master/social/update",
  ADMIN_UPDATE_QR: "master/qr/update",
  ADMIN_DELETE_QR: "master/qr/delete",
  ADMIN_UPDATE_UPI: "master/upi/update",
  ADMIN_DELETE_UPI: "master/upi/delete",
  ANNOUNCEUPDATE: "master/announcement/update",
  COMMISSIONUPDATE: "master/commission/update",
  COMMISSIONHITORY: "commission/history",
  PRICELIST: "games/price-list",
  PRICEUPADTE: "games/game-price",
  LOTPRICELIST: "lotprice/price-list",
  LOTPRICEUPDATE: "lotprice/lot-price",
  APPTIME: "games/timings",
  HOLIDAYUPDATE: "games/holiday/leave",
  HOLAIDYOVERALL: "games/holiday/leave-overall",
  GETGMAELIST: "games/list",
  GETALLHOLIDAY: "games/holiday",
  REPORTDRAW: "games/datewise-game",
  OTHERREPORT: "games/statusdatewise-game",
  DRAWREPORT: "games/report/draw",
  OVERALLRESULT: "games/overall-list",
  RESULTANNOUNCE: "games/winning/make",
  DECLAREPOST: "games/winning/declare",
  CHAT: "chat",
  CHATSEND: "chat/send",
  NOTIFICATION: "notifications",
  BLOCKEDCLIENT: "clients/block",
  CLIENTACTIVITY: "clients/activity",
  DELETEDATA: "games/report/export",
  DASHBOARD: "dashboard",
  PURCHASEREPORT: "games/report/client/purches",
  SALESREPORT: "games/report",
  UPLOAD_LOG: "upload-log",
  DROWSTATUS: "notifications/winning",
  CHATHISTORY: "chat/history",
  CLIENTSEARCH:"/clients",
  CHATNEW: "/chat/search",
};

export const ICON_FILTER ="brightness(0) saturate(100%) invert(9%) sepia(90%) saturate(4500%) hue-rotate(315deg) brightness(75%) contrast(120%)";